export const DEFAULT_ADULTS = 2;
export const DEFAULT_CHILDREN = 0;
export const DEFAULT_INFANTS = 0;
export const DEFAULT_ROOMS = 1;

export const DEFAULT_GUESTS = {
  adults: DEFAULT_ADULTS,
  children: DEFAULT_CHILDREN,
  infants: DEFAULT_INFANTS,
  rooms: DEFAULT_ROOMS,
};
